import type { PropsWithChildren } from 'react';
import { AnalyticsProvider } from './context';
import { RuptProvider } from './rupt';

export function AnalyticsToolsProvider({ children }: PropsWithChildren) {
  return (
    <>
      <RuptProvider />
      <AnalyticsProvider>{children}</AnalyticsProvider>
    </>
  );
}
